import React from 'react';
import useAuthoringTranslations from '../../../../hooks/stores/useAuthoringTranslations'
import { useShallow } from 'zustand/react/shallow'
import { Divider } from 'antd'

// styles
import './PreviewWrapper.scss'

const PreviewWrapper = (WrappedComponent) => (props) => {
  const formatOptions = (rjProps) => {
    let options = rjProps.uiSchema && rjProps.uiSchema["ui:options"] ? rjProps.uiSchema["ui:options"] : rjProps.options;
    let label = options.title;

    if (label === "data-schema") {
      label = `        ${rjProps.schema.title}: `;
    }
    let res = {
      ...options,
      label
    }

    if (rjProps?.schema?.uiSchema) {
      res = {
        ...res,
        ...rjProps.schema.uiSchema
      }
      if (rjProps.schema.label) {
        res.label = rjProps.schema.label
      }
    }

    return res;
  }

  return <PreviewComponent
    {...props}
    formatOptions={formatOptions}
    WrappedComponent={WrappedComponent}
  />
};

const PreviewComponent = (props) => {
  const {
    WrappedComponent,
    formatOptions,
    uiSchema,
    formContext
  } = props

  const {
    isTranslationActive,
    selectedLanguage
  } = useAuthoringTranslations(
    useShallow((state) => ({
      selectedLanguage: state.selectedLanguage,
      isTranslationActive: state.isTranslationActive,
    }))
  )

  let options = formatOptions(props);

  if (options.hide === true) {
    return null;
  }

  const classNames = ['preview-hoc-wrapper-container']
  if (isTranslationActive) {
    classNames.push("translate-active")
  }

  const renderTranslationComponent = () => {
    return (
      <div className='flex-1'>
        <WrappedComponent
          {...props}
          isTranslation={true}
          selectedLanguage={selectedLanguage}
          carbonProps={{
            ...options,
            label: uiSchema["ui:options"]?.translations?.[selectedLanguage]?.title || options.label
          }}
          value={formContext?.formData?.translations?.[selectedLanguage]?.[props.id.replace("root.", "")]}
        />
      </div>
    )
  }

  return (
    <>
      <div
        key={props.id}
        className={classNames.join(" ")}>
        <div className='flex-1'>
          <WrappedComponent
            {...props}
            dotNotation={props.id.slice(5)}
            id={props.id.replaceAll(".", "_")}
            carbonProps={options}
          />
        </div>
        {isTranslationActive && selectedLanguage && renderTranslationComponent()}
      </div>
      {isTranslationActive && <Divider style={{ margin: 0 }} />}
    </>
  )
}

export default PreviewWrapper;